class MemoryStorage {
  constructor () {
    this._data = {}
  }

  getItem (key) {
    return this._data[key] === undefined ? null : this._data[key]
  }

  setItem (key, item) {
    this._data[key] = item
    return this
  }

  removeItem (key) {
    delete this._data[key]
    return this
  }

  clear () {
    this._data = {}
    return this
  }
}

class Storage {
  setRememberMe (bRemember) {
    this.getLocalStorage().setItem('appRememberMe', JSON.stringify(bRemember))
  }

  setDemoMode (isDemoMode) {
    this.getSessionStorage().setItem('isDemoMode', JSON.stringify(isDemoMode))
  }

  getStorage () {
    if (
      this.getSessionStorage().getItem('isDemoMode') === 'true' ||
      this.getLocalStorage().getItem('appRememberMe') === 'false'
    ) {
      return this.getSessionStorage()
    }

    return this.getLocalStorage()
  }

  getLocalStorage () {
    return window.localStorage || new MemoryStorage()
  }

  getSessionStorage () {
    return window.sessionStorage || new MemoryStorage()
  }

  getItem (key) {
    return this.getStorage().getItem(key)
  }

  setItem (key, item) {
    this.getStorage().setItem(key, item)
    return this
  }

  removeItem (key) {
    this.getStorage().removeItem(key)
    return this
  }

  clear () {
    this.getLocalStorage().removeItem('appRememberMe')
    this.getStorage().clear()
    return this
  }
}

export default new Storage()
